import { render } from "./case.vue?vue&type=template&id=0c6aef62&scoped=true"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"

import "./case.vue?vue&type=style&index=0&id=0c6aef62&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6aef62"]])

export default __exports__